import { sysBreadcrumbConfig } from './config';
import type { IBreadcrumbConfig } from './types';

export const breadcrumbConfig: IBreadcrumbConfig = {
  '/my': 'Home',
  '/my/billing': 'Billing',
  '/account': 'Account',
  '/account/profile': 'Profile',
  '/account/security': 'Security',
  '/account/security/sessions': 'Sessions',
  ...sysBreadcrumbConfig,
};
